import Modals from 'application/ui/modal/modal'

const MODAL_NAME = 'adult_warning_modal'

/**
 * Возрастной гейт на странице квеста «для взрослых».
 *
 * Само окно показывается автоматически (data-auto-show) и закрыто от обхода
 * (data-disable-user-close): клик по фону и Escape его не убирают. Поэтому
 * кнопка «да» закрывает окно программно — этот путь запрет не проверяет.
 */
export function initAdultWarning(): void {
  const modalEl = document.querySelector<HTMLElement>(
    `[data-modal-name="${MODAL_NAME}"]`
  )

  if (!modalEl) {
    return
  }

  modalEl.addEventListener('click', (event) => {
    const confirmBtn = (event.target as HTMLElement).closest(
      '[data-adult-confirm]'
    )

    if (!confirmBtn) {
      return
    }

    Modals.getInstance().closeModal(MODAL_NAME)
  })
}
